import * as yup from 'yup'

export const validateCreateWorkOffers = yup.object().shape({
    path_cover:yup
    .string()
    .required('Campo requerido.')
    .min(2, 'La IMAGEN debe tener más de 2 caracteres'),
    job:yup
    .string()
    .required('Campo requerido.')
    .min(2, 'El TRABAJO debe tener más de 2 caracteres'),
    category_id:yup
    .number().typeError('Campo requerido.')
    .required('Campo requerido.')
    .positive(),
    city_id:yup
    .number().typeError('Campo requerido.')
    .required('Campo requerido.')
    .positive(),
    address: yup
    .string()
    .required('Campo requerido.')
    .min(7, 'El DIRECCIÓN debe tener más de 6 caracteres'),
    company_name:yup
    .string()
    .required('Campo requerido.')
    .min(2, 'La COMPAÑÍA debe tener más de 2 caracteres'),
    salary:yup
    .number().typeError('Campo requerido.')
    .positive()
    .min(0, 'Debe de utilizar un numero que no sea negativo'),
    job_type:yup
    .string()
    .required('Campo requerido.')
    .oneOf(['tiempo_completo', 'medio_tiempo', 'trabajo_independiente'], 'Debes elegir entre estas opciones'),
    description:yup
    .string()
    .required('Campo requerido.')
    .min(2, 'LA DESCRIPCIÓN debe tener más de 2 caracteres'),
    requirements:yup
    .string()
    .required('Campo requerido.')
    .min(2, 'LOS REQUERIMIENTOS debe tener más de 2 caracteres'),
    responsibilities:yup
    .string()
    .required('Campo requerido.')
    .min(2, 'LAS RESPONSABILIDADES debe tener más de 2 caracteres'),
})